export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/onboarding-close.png?fcf97be80448bcc424c8d68916260499";